import { render, staticRenderFns } from "./CatapultBanner.vue?vue&type=template&id=573ea3e4&scoped=true"
import script from "./CatapultBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatapultBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CatapultBanner.vue?vue&type=style&index=0&id=573ea3e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ea3e4",
  null
  
)

export default component.exports